module.exports = __webpack_public_path__ + "img/maui.52f74e10.jpg";